<template>
    <div>
        <vs-row>
            <vs-col w="12">
                <div class="card">
                    <div class="card-body">
                        <vs-row style="display: flex; justify-content: center; align-items: self-end;">
                            <vs-col sm="12" lg="8">
                                <vs-row>
                                    <vs-col sm="12" lg="2">
                                        <vs-avatar size="100" circle class="m-auto">
                                            <img :src="'/api/personas/' + persona_id + '/avatar'" @error="setAltImg" alt="" style="object-fit: contain;">
                                        </vs-avatar>
                                    </vs-col>
                                    <vs-col sm="12" lg="10">
                                        <h5 class="text-uppercase">{{user.nombre}}</h5>
                                        <h6><small>MATRÍCULA: </small>{{user.matricula}}</h6>
                                    </vs-col>
                                </vs-row>
                            </vs-col>
                            <vs-col sm="12" lg="4">
                                <vs-button
                                    v-if="carrera_doble == 'si'"
                                    flat
                                    @click="activePrograma =! activePrograma"
                                >
                                    Solicitar registro a otro programa en esta Universiad
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </div>
                </div>
            </vs-col>
            <vs-col xs="12" lg="4" class="mt-3 px-2" v-for="(option, i) in user.registros_academicos" :key="i">
                <div class="card">
                    <div class="card-body">
                        <h5>{{option.institucion}}</h5>
                        <h6 style="font-weight: 200">{{option.programa}}</h6>
                        <div class="steamline mt-5">
                            <div class="sl-item" v-for="(registro, index) in option.registros_academicos_programa" :key="index">
                                <div v-if="colores[registro.status]" class="sl-left" :class="colores[registro.status]['colorIcon']"> 
                                    <i :class="colores[registro.status]['icon']"></i>
                                </div>
                                <div class="sl-right">
                                    <div>
                                        <h6 class="mb-2">{{registro.ciclo_escolar}}</h6>
                                    </div>
                                    <div class="mb-2" v-if="registro.status != 'concluido' && colores[registro.status]">
                                        <small><strong><span class="badge-pill colorWhite text-uppercase" :class="colores[registro.status]['letreroColor']">{{colores[registro.status]['letrero']}}</span></strong></small>
                                    </div>                              
                                    <div>
                                        <h6 class="mb-2">{{registro.grado}}</h6>
                                    </div>
                                    <md-chip  v-if="registro.status_reinscripcion == 'ciclo_cerrado' && registro.status == 'proximo' " class="mini-chip col-red mb-2" ><strong>Ciclo escolar cerrado a inscripciones</strong></md-chip>
                                    <div style="margin-bottom: 20px;" v-if="registro.status == 'proximo'">
                                        <vs-button
                                            v-if="registro.status_reinscripcion == 'abierto' && (getInstitucionesUsario(option.institucion_id) || JSON.parse(persona).tipoUserPrincipal == 'Personal central - TI')" 
                                            success
                                            border
                                            @click="activeInscripcion =! activeInscripcion, infoPrograma = registro, selectRow = option"
                                        >
                                            Realizar inscripción
                                        </vs-button>
                                    </div>

                                    <div style="margin-bottom: 20px;" v-if="registro.status == 'porconfirmar' && JSON.parse(persona).roles[0].name != 'Usuario Principal' && registro.status_reinscripcion == 'abierto'">
                                        <vs-button
                                            v-if="(option.institucion_id == JSON.parse(persona).roles[0].institucion_id || JSON.parse(persona).tipoUserPrincipal == 'Personal central - TI')"
                                            danger
                                            border
                                            @click="activeConfirmarIncripcion =!activeConfirmarIncripcion, infoPrograma = registro, selectRow = option"
                                        >
                                            Confirmar inscripción
                                        </vs-button>
                                    </div>
                                       
                                    <div style="margin-bottom: 20px;" class="d-flex" v-if="registro.status == 'actual'">
                                        <div>
                                            <vs-tooltip>
                                                <vs-button
                                                    circle
                                                    icon
                                                    color="#CCD1D1"
                                                    border
                                                    blank
                                                    @click="getComprobanteInscripcion(registro.registro_academico_id)"
                                                >
                                                    <i class="fas fa-cloud-download-alt font-medium" style="color: #707B7C; font-size: 12px; padding: 5px;"></i>
                                                </vs-button>
                                                <template #tooltip>
                                                    Descargar comprobante de inscripción
                                                </template>
                                            </vs-tooltip>
                                        </div>
                                        <div v-if="JSON.parse(persona).roles[0].name != 'Usuario Principal'">
                                            <vs-tooltip v-if="(option.institucion_id == JSON.parse(persona).roles[0].institucion_id || JSON.parse(persona).tipoUserPrincipal == 'Personal central - TI')">
                                                <vs-button
                                                    circle
                                                    icon
                                                    color="#CCD1D1"
                                                    border
                                                    @click="activeEditar =! activeEditar, selectRow = option, infoPrograma = registro"
                                                >
                                                    <i class="far fa-edit" style="color: #707B7C; font-size: 12px; padding: 5px;"></i>
                                                </vs-button>
                                                <template #tooltip>
                                                    Editar grado
                                                </template>
                                            </vs-tooltip>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-col>
        </vs-row>

        <modal-editar v-model="activeEditar" :token="csrf_token" :row="selectRow" :infoPrograma="infoPrograma" @refreshInfo="getInscripcionAcademica"></modal-editar>

        <modal-programa v-model="activePrograma" :persona_id="persona_id" :token="csrf_token" :programa="user" @refreshInfo="getInscripcionAcademica"></modal-programa>

        <modal-inscripcion v-model="activeInscripcion" :infoPrograma="infoPrograma" :row="selectRow" :persona_id="persona_id"  @refreshInfo="getInscripcionAcademica"></modal-inscripcion>

        <modal-confirmar v-model="activeConfirmarIncripcion" :infoPrograma="infoPrograma" @refreshInfo="getInscripcionAcademica" :row="selectRow"></modal-confirmar>
    </div>
</template>

<script>
import ModalEditar from './modal/editar.vue'
import ModalPrograma from './modal/programa.vue'
import ModalInscripcion from './modal/inscripcion.vue'
import ModalConfirmar from './modal/confirmar.vue'
import landing from '../../../../api/requests/landing'
export default {
    props:[
        'csrf_token',
        'persona',
        'persona_id',
        'institucionesUsuario'
    ],
    data:() => ({
        user: [],
        carrera_doble: '',
        activeEditar: false,
        activePrograma: false,
        activeInscripcion: false,
        activeConfirmarIncripcion: false,
        selectRow: [],
        infoPrograma: [],
        colores: {
            "proximo": {
                "colorIcon": "bg-warning",
                "icon": "fas fa-spinner",
                "letreroColor": "badge-warning",
                "letrero": "PRÓXIMO REGISTRO ACADÉMICO"
            },
            "actual": {
                "colorIcon": "bg-success",
                "icon": "far fa-circle",
                "letreroColor": "badge-success",
                "letrero": "REGISTRO ACADÉMICO ACTUAL"
            },
            "concluido": {
                "colorIcon": "bg-default",
                "icon": "fas fa-check",
            },
            "porconfirmar": {
                "colorIcon": "bg-danger",
                "icon": "far fa-circle",
                "letreroColor": "badge-danger",
                "letrero": "REGISTRO ACADÉMICO POR CONFIRMAR"
            },
        },
    }),
    components:{
       ModalEditar,
       ModalPrograma,
       ModalInscripcion,
       ModalConfirmar 
    },
    created(){
       this.getInscripcionAcademica() 
    },
    methods:{
        async getInscripcionAcademica(){
            // var actual = window.location+'';
            // var split = actual.split("/");
            // this.persona_id = split[split.length-1];

            const params = {
                persona_id: this.persona_id
            }
            const {data: response} = await landing.getInscripcionAcademica(params)
            this.user = response
            this.carrera_doble = response.registros_academicos[0].carrera_doble
            this.$emit("infoRegistroAcademico", response)
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
        getComprobanteInscripcion(registro){
            const url = '/alumnos/descargarComprobanteInscripcion?registro_academico=' + registro
            window.open(url)
        },
        getInstitucionesUsario(institutoAlumno){
            const inst = this.institucionesUsuario.map(e => e.id)
            return (inst).includes((institutoAlumno)) ? true : false
        }
    },
    watch:{
       persona_id(){
        this.getInscripcionAcademica() 
       } 
    }
}
</script>

<style scoped>
    .steamline{
        position: relative;
        border-left: 1px solid rgba(120, 130, 140, 0.13);
        margin-left: 20px
    }

    .steamline .sl-item{
        border-bottom: 1px solid rgba(120, 130, 140, 0.13);
        margin: 20px 0
    }

    .steamline .sl-left{
        float: left;
        margin-left: -20px;
        z-index: 1;
        width: 40px;
        line-height: 40px;
        text-align: center;
        height: 40px;
        border-radius: 100%;
        color: #fff;
        background: #263238;
        margin-right: 15px;
    }

    .steamline .sl-right{
        padding-left: 50px;
    }

    .colorWhite{
        color: white;
        padding: 0.5% 2%;
    }
    
    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .md-chip{
        font-size: 12px !important;
    }
</style>